<div class="alert-modal" [class.alert-modal--error]="isError" [class.alert-modal--warning]="isWarning"
     role="dialog" [attr.aria-labelledby]="'alert-modal-title'" [attr.aria-describedby]="'alert-modal-desc'">
  <header class="alert-modal-header">
    <div class="alert-modal-icon" aria-hidden="true">
      <i class="fas fa-exclamation-circle" *ngIf="isError"></i>
      <i class="fas fa-exclamation-triangle" *ngIf="isWarning"></i>
    </div>
    <h2 id="alert-modal-title" class="alert-modal-title">{{ title }}</h2>
  </header>
  <div class="alert-modal-body">
    <p id="alert-modal-desc" class="alert-modal-message">{{ message }}</p>
  </div>
  <footer class="alert-modal-actions">
    <button type="button" class="btn btn-primary alert-modal-btn" (click)="close()" aria-label="Entendido" cdkFocusInitial>
      Entendido
    </button>
  </footer>
</div>
